import React, { useEffect } from 'react';
import styles from './CouponUnlockableMessage.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

/* Assets */
import couponIcon from '../../assets/icons/coupon.png';

/* Providers */
import { useProductContext } from '../../__providers__/ProductContext';
import { usePaymentTypeContext } from '../../__providers__/PaymentTypeContext';

/* Interfaces */
import { PaymentTypesReversed } from '../../interfaces/payment_types';

interface CouponUnlockableMessageProps {}

export const CouponUnlockableMessage: React.FC<
  CouponUnlockableMessageProps
> = () => {
  const { t } = useTranslation();
  const { product } = useProductContext();
  const { setSelectedPayment } = usePaymentTypeContext();

  useEffect(() => {
    setSelectedPayment(PaymentTypesReversed.Ticket);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.couponContainer}>
        <img src={couponIcon} alt="Coupon Icon" className={styles.icon} />

        <span className={styles.msg}>
          {product.unlockableType === 'UNIVERSAL'
            ? tr(t, 'universal_ticket')
            : t('coupon_from', { tipster: product.unlockedFrom })}
        </span>
        <div className={styles.selectBtn}>
          <button className={styles.selected}></button>
        </div>
      </div>
    </div>
  );
};
